import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  Elements,
  CardElement,
  useStripe,
  useElements,
} from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import axios from "axios";
import { CheckCircle } from "@mui/icons-material";

import PhoneInput from "react-phone-input-2";
import { useParams, useSearchParams } from "react-router-dom";
import FeaturesSection from "../Components/FeatureSection";

const stripePromise = loadStripe(
  "pk_test_51QK41LKiuI59bkOcQzA0wU1C7HcuqAxbBFUAhtzD4fZ6M9GUqAZw3x9mtuwbZegiG2ZhGNz42jVx21vcqZU3HTO700a9oaKrSR"
);

const PaymentForm = () => {
  const [selectedPlan, setSelectedPlan] = useState("0");
  const [billingCycle, setBillingCycle] = useState("1");
  const [userData, setUserData] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [notification, setNotification] = useState("");
  const [searchParams, setSearchParams] = useSearchParams();

  const stripe = useStripe();
  const elements = useElements();
  const { selected_plan = 0 } = useParams();
  useEffect(() => {
    if ([0, 1, 2, 3].filter((a) => +selected_plan === a).length)
      setSelectedPlan(selected_plan);
  }, [selected_plan]);
  useEffect(() => {
    setUserData({
      first_name: searchParams.get("first_name"),
      last_name: searchParams.get("last_name"),
      email: searchParams.get("email"),
      phone_number: searchParams.get("phone_number"),
      password: searchParams.get("password"),
    });
  }, [searchParams]);

  useEffect(() => {
    setTimeout(() => {
      setNotification("");
    }, 5000);
  }, [notification]);

  const getFinalPayment = useMemo(() => {
    const prices = {
      1: { 1: 45, 3: 75, 6: 150 },
      2: { 1: 102, 3: 175, 6: 350 },
      3: { 1: 195, 3: 325, 6: 650 },
    };
    return +selectedPlan !== 0 ? prices[selectedPlan][billingCycle] : 0;
  }, [billingCycle, selectedPlan]);
  const updateSuscription = async () => {
    await axios.post("/users/update-subscription", {
      selected_plan: selectedPlan,
      billing_cycle: billingCycle,
      email: userData.email,
    //   phone_number: userData.phone_number,
    //   first_name: userData.first_name,
    //   last_name: userData.last_name,
    });
    setNotification(
      +selectedPlan === 0
        ? "Your are downgraded to free plan."
        : "Payment successful! Thank you for subscribing."
    );

    setUserData({});
    setSelectedPlan(0);
    setBillingCycle("1");
    if (searchParams.get("isMobile") === "true") {
      //close tab
      return window.close();
    }
    window.location = "https://www.synkoria.com/thank-you-for-registering/";
  };
  const updatePayment = async () => {
    if (!userData?.phone_number) {
      setError("Please enter your phone number.");
      return;
    }
    if (userData?.phone_number.length < 10) {
      setError("Please enter a valid phone number.");
      return;
    }

    if (!userData?.email) {
      setError("Please enter your email.");
      return;
    }
    // validate email formate
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(userData?.email)) {
      setError("Please enter a valid email.");
      return;
    }

    if (!userData?.password) {
      setError("Please enter your password.");
      return;
    }

    let isEmailExist = false;
    let res = await axios.get("/users/check-email/" + userData.email);

    isEmailExist = res.data.success;

    if (!isEmailExist) {
      setError("Email is not exist in the system, try another one.");
      setNotification(
        "Email is not exist in the system, try another one or login."
      );
      return;
    }

    if (+selectedPlan === 0) {
      updateSuscription();
      return;
    }

    if (!stripe || !elements) {
      setError("Stripe has not loaded yet. Please try again later.");
      return;
    }

    const cardElement = elements.getElement(CardElement);

    if (!cardElement) {
      setError("Please enter your card details.");
      return;
    }

    try {
      setLoading(true);
      setError("");

      const response = await axios.post("/users/create-payment-intent", {
        amount: getFinalPayment * 100, // Convert to cents
        currency: "usd",
        metadata: {
          first_name: userData?.first_name,
          last_name: userData?.last_name,
          email: userData?.email,
          phone_number: userData?.phone_number,
          plan: selectedPlan,
          billing_cycle: billingCycle,
        },
      });

      const { clientSecret } = response.data;

      const paymentResult = await stripe.confirmCardPayment(clientSecret, {
        payment_method: {
          card: cardElement,
          billing_details: {
            name: `${userData?.first_name} ${userData?.last_name}`,
            email: userData?.email,
          },
        },
      });

      if (paymentResult.error) {
        setError(paymentResult.error.message);
      } else if (paymentResult.paymentIntent.status === "succeeded") {
        updateSuscription();
      }
    } catch (error) {
      setError("Payment failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="sign_up_page"
      style={{
        padding: "10px 0",
        maxWidth: "1200px",
      }}
    >
      {notification ? (
        <div className="success_dialogue">
          <div className="success_dialogue_icon">
            <CheckCircle />
          </div>
          <div className="success_dialogue_heading">{notification}</div>
        </div>
      ) : (
        ""
      )}

      <div
        className="sign_up_form_body"
        style={{
          maxWidth: "90vw",
        }}
      >
        <div className="sign_up_form_heading1">SYNKORIA Upgrade Form</div>

        <div
          className="row"
          style={{
            width: "90vw",
            maxWidth: "1200px",
          }}
        >
          <div className="sign_up_form">
            <div
              className="row"
              style={{
                fontSize: "1rem",
                padding: "10px 0",
              }}
            >
              {+selectedPlan === 0
                ? "Free Plan"
                : `Your Plan: $${getFinalPayment}`}
            </div>
            <div className="row">
              <div className="input-wrapper">
                <select
                  type="text"
                  placeholder="Plan"
                  value={selectedPlan}
                  onChange={(e) => setSelectedPlan(e.target.value)}
                  style={{
                    width: "95%",
                    height: "50px",
                  }}
                >
                  <option value={0}>Free</option>
                  <option value={1}>Com 1</option>
                  <option value={2}>Com 2</option>
                  <option value={3}>Com 3</option>
                  {/* <option value={4}>Com 4</option> */}
                </select>
              </div>
              {+selectedPlan ? (
                <div className="input-wrapper">
                  <select
                    type="text"
                    placeholder="Billing Cycle"
                    value={billingCycle}
                    onChange={(e) => setBillingCycle(e.target.value)}
                    style={{
                      width: "95%",
                      height: "50px",
                    }}
                  >
                    <option value="1">1 Month</option>
                    <option value="3">3 Months</option>
                    <option value="6">6 Months</option>
                  </select>
                </div>
              ) : (
                ""
              )}
            </div>

            <div className="row">
              <div className="input-wrapper">
                <input
                  type="text"
                  placeholder="First Name"
                  value={userData?.first_name || ""}
                  onChange={(e) =>
                    setUserData((prev) => ({
                      ...prev,
                      first_name: e.target.value,
                    }))
                  }
                />
                {userData?.first_name && (
                  <span
                    className="clear-icon"
                    onClick={() =>
                      setUserData((prev) => ({ ...prev, first_name: "" }))
                    }
                  >
                    &times;
                  </span>
                )}
              </div>
              <div className="input-wrapper">
                <input
                  type="text"
                  placeholder="Last Name"
                  value={userData?.last_name || ""}
                  onChange={(e) =>
                    setUserData((prev) => ({
                      ...prev,
                      last_name: e.target.value,
                    }))
                  }
                />
                {userData?.last_name && (
                  <span
                    className="clear-icon"
                    onClick={() =>
                      setUserData((prev) => ({ ...prev, last_name: "" }))
                    }
                  >
                    &times;
                  </span>
                )}
              </div>
            </div>
            <div className="row">
              <div className="input-wrapper">
                <PhoneInput
                  country={"us"} // Default country code
                  value={userData?.phone_number || ""}
                  onChange={(phone, country) =>
                    setUserData((prev) => ({
                      ...prev,
                      phone_number: phone,
                      country_code: country.dialCode,
                    }))
                  }
                  inputStyle={{
                    width: "250px",
                    marginBottom: "1rem",
                    border: "none",
                    borderRadius: "5px",
                    boxShadow: "none",
                    height: "30px",
                    fontSize: "1rem",
                  }}
                />
                {userData?.phone_number && (
                  <span
                    className="clear-icon"
                    onClick={() =>
                      setUserData((prev) => ({ ...prev, phone_number: "" }))
                    }
                  >
                    &times;
                  </span>
                )}
              </div>

              <div className="input-wrapper">
                <input
                  type="text"
                  placeholder="Email"
                  value={userData?.email || ""}
                  onChange={(e) =>
                    setUserData((prev) => ({
                      ...prev,
                      email: e.target.value,
                    }))
                  }
                />
                {userData?.email && (
                  <span
                    className="clear-icon"
                    onClick={() =>
                      setUserData((prev) => ({ ...prev, email: "" }))
                    }
                  >
                    &times;
                  </span>
                )}
              </div>
            </div>
            <div className="row">
              <div className="input-wrapper">
                <input
                  type="password"
                  placeholder="Password"
                  value={userData?.password || ""}
                  onChange={(e) =>
                    setUserData((prev) => ({
                      ...prev,
                      password: e.target.value,
                    }))
                  }
                />
                {userData?.password && (
                  <span
                    className="clear-icon"
                    onClick={() =>
                      setUserData((prev) => ({ ...prev, password: "" }))
                    }
                  >
                    &times;
                  </span>
                )}
              </div>
            </div>
            {+selectedPlan === 0 ? (
              ""
            ) : (
              <>
                <div
                  className="row"
                  style={{
                    fontSize: "1.3rem",
                    padding: "10px 0",
                  }}
                >
                  Card Details:
                </div>
                <div
                  style={{
                    marginBottom: "15px",
                    width: "90%",
                    border: "2px solid #007cd7",
                    padding: "15px 12px",
                    borderRadius: "5px",
                    maxWidth: "570px",
                    backgroundColor: "#f9f9f9",
                  }}
                  className="row"
                >
                  <CardElement
                    id="card-element"
                    options={{
                      style: {
                        base: {
                          fontSize: "16px",
                          color: "#424770",
                          "::placeholder": { color: "#aab7c4" },
                        },
                        invalid: { color: "#9e2146" },
                      },
                    }}
                    style={{
                      padding: "10px",
                      borderRadius: "5px",
                      border: "1px solid #ccc",
                      minHeight: "50px",
                      width: "100%", // Ensure it spans the container
                      maxWidth: "80vw",
                    }}
                  />
                </div>
              </>
            )}
            {loading ? (
              <button id="loading-screen" className="sign_up_form_button">
                <svg viewBox="0 0 100 100">
                  <path
                    d="M10 50A40 40 0 0 0 90 50A40 44.8 0 0 1 10 50"
                    fill="#fff"
                    stroke="none"
                  >
                    <animateTransform
                      attributeName="transform"
                      type="rotate"
                      dur="1s"
                      repeatCount="indefinite"
                      keyTimes="0;1"
                      values="0 50 51;360 50 51"
                    ></animateTransform>
                  </path>
                </svg>
              </button>
            ) : (
              <button onClick={updatePayment} className="sign_up_form_button">
                {+selectedPlan === 0 ? "Downgrade" : "Submit Payment"}
              </button>
            )}
            {error ? <p style={{ color: "red" }}>{error}</p> : ""}
          </div>

          <div
            className="sign_up_form"
            style={{
              maxWidth: "500px",
            }}
          >
            <FeaturesSection />
          </div>
        </div>
      </div>
    </div>
  );
};

const PaymentUpgradeForm = () => {
  return (
    <Elements stripe={stripePromise}>
      <PaymentForm />
    </Elements>
  );
};

export default PaymentUpgradeForm;
